import { useContext, useState } from "react";
import { WarningAlert } from "../../alerts/WarningAlert";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import Box from "@mui/material/Box";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useMutation } from "@apollo/client";
import CheckPermission from "../../helpers/Administradores/Permissions";
import {
  DELETE_TRAININGPLAN,
  GET_ALL_TRAININGPLANS,
} from "../../Querys/querys";
import { ErrorAlert } from "../../alerts/errorAlert";
import { SuccessfulAlert } from "../../alerts/successAlerts";
import { updateModalTrainingPlan } from "../../context/FormacionDesarollo/TrainingPlansActions";
import TrainingPlansContext from "../../context/FormacionDesarollo/TrainingPlansContext";
import { useHistory } from "react-router-dom";

type MenuTrainingPlanProps = {
  id: number;
  active: string;
  isEditable: boolean;
};
export const MenuTrainingPlan = ({
  id,
  active,
  isEditable,
}: MenuTrainingPlanProps) => {
  const { dispatch } = useContext(TrainingPlansContext);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const history = useHistory();
  const open = Boolean(anchorEl);
  const permisoEditar = CheckPermission(
    "FormacionDesarrollo.TrainingPlans.Editar"
  );
  const permisoEliminar = CheckPermission(
    "FormacionDesarrollo.TrainingPlans.Eliminar"
  );

  const openMenu = (e: any): void => {
    setAnchorEl(e.currentTarget);
  };

  const [deleteTrainingPlan] = useMutation(DELETE_TRAININGPLAN, {
    refetchQueries: [{ query: GET_ALL_TRAININGPLANS }],
  });

  const verCurso = (id: number, verModal: boolean) => {
    setAnchorEl(null);
    console.log(id, verModal);
    // updateCalendarsModal(id, updateModal, dispatch)
  };

  const updateModal = (id: number, updateModal: boolean) => {
    setAnchorEl(null);
    console.log("aaaa");
    updateModalTrainingPlan(id.toString(), updateModal, dispatch);
  };

  const deleteModal = async (id: any) => {
    setAnchorEl(null);
    let response = await WarningAlert({
      text: "¿Deseas eliminar este plan de capacitación?",
      showDenyButton: true,
      confirmButtonText: "Eliminar",
    });
    if (response.isConfirmed) {
      try {
        await deleteTrainingPlan({
          variables: {
            deleteTrainingplanId: parseInt(id),
          },
        });
        await SuccessfulAlert({
          text: "Plan de capacitación eliminado correctamente.",
        });
      } catch (error) {
        ErrorAlert({
          text: "Ocurrió un error al intentar eliminar el plan de capacitación.",
        });
      }
    }
  };

  const menuDelete = (active: any) => {
    return (
      <MenuItem
        onClick={() => deleteModal(id)}
        disabled={active === "Activo" ? true : false}
      >
        <div className="contenedorTextoMenuCourse">
          <span className="textoMenuEliminarCourse">Eliminar</span>
        </div>
        <div className="imgDeleteCourse">
          <img
            className="iconoMenuEliminarCourse"
            src="/assets/svg/icono-eliminar.svg"
            alt="Eliminar"
          />
        </div>
      </MenuItem>
    );
  };
  return (
    <>
      <Box mr={2} className="menuListNewCourse">
        <IconButton onClick={openMenu} className="menuListOptionNewCourse">
          <MoreVertIcon className="moreOptionNewCourse" />
        </IconButton>
      </Box>
      <Menu
        className="MoreVerIcon"
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        {CheckPermission("FormacionDesarrollo.Cursos.Ver") && (
          <MenuItem
            onClick={() => {
              history.push(`/capacitacionesTP/${id}`);
            }}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Información</span>
            </div>
            <div>
              <VisibilityIcon className="iconoMenuViewCourse" />
            </div>
          </MenuItem>
        )}
        {permisoEditar && (
          <MenuItem
            onClick={() => updateModal(id, true)}
            disabled={isEditable ? false : true}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Editar</span>
            </div>
            <div className="imgEditaCourse">
              <img
                className="iconoMenuCourse"
                src="/assets/svg/icono-editar.svg"
                alt="Editar"
              />
            </div>
          </MenuItem>
        )}
        {permisoEliminar && menuDelete(active)}
      </Menu>
    </>
  );
};

export default MenuTrainingPlan;
